import { Component, OnInit } from '@angular/core';
import { User } from 'src/app/model/user';
import { UserService } from 'src/app/service/user.service';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-first-change-password',
  templateUrl: './first-change-password.component.html',
  styleUrls: ['./first-change-password.component.css']
})
export class FirstChangePasswordComponent implements OnInit {

    user: User;

    constructor(
        private userSrv: UserService
    ) { }

    ngOnInit() {
        this.getUser();
    }

    private getUser() {
        this.userSrv.getUser()
        .pipe(first())
        .subscribe(
            data => {
                this.user = data;
            },
            error => {
                return;
            }
        );
    }

}
